<template>
  <div class="card same-height">
    <div class="card-image">
      <b-carousel
        :autoplay="false"
      >
        <b-carousel-item
          v-for="(carousel, i) in productInfo.images"
          :key="i"
        >
          <figure class="image">
            <img
              :src="getImgUrl(carousel)"
              ratio="601by235"
            >
          </figure>
        </b-carousel-item>
      </b-carousel>
    </div>
    <div class="card-content" @click="pushToRouterPath(productInfo.routeName)">
      <div class="content">
        <div class="is-size-3">
          <a>{{ productInfo.name }}</a>
        </div>

        {{ productInfo.description }}
        <br>
        <time datetime="2016-1-1">11:09 PM - 1 Jan 2016</time>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    productInfo: {
      type: Object,
      name: 'undefined',
      images: [],
      description: 'undefined'
    }
  },
  data () {
    return {
      carousels: [
        { text: 'Slide 1', color: 'primary' },
        { text: 'Slide 2', color: 'info' },
        { text: 'Slide 3', color: 'success' },
        { text: 'Slide 4', color: 'warning' },
        { text: 'Slide 5', color: 'danger' }
      ]
    }
  },
  methods: {
    getImgUrl (value) {
      return value
    },
    pushToRouterPath (routeName) {
      this.$router.push({ name: routeName })
    }
  }
}
</script>

<style>
.same-height {
  height: 100%;
  display:flex;
  flex-direction: column;
}

.same-height:hover {
  background-color:grey;
}
</style>
